<script>
  import { createNamespacedHelpers } from 'vuex';

  const { mapGetters } = createNamespacedHelpers('hitch');

  export default {
    name: 'Preview',
    props: {
      /** The currently selected frame variant */
      variant: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        'getUserTextAsArray',
        'getCustomizationStyle',
        'getLargeLetterStyle',
        'getSmallLetterStyle'
      ]),
      /** Returns the array of letter objects to display on the preview */
      displayLetters() {
        const letterArray = [];
        const displayLetters = this.getUserTextAsArray.length ? this.getUserTextAsArray : this.placeholder;
        const limit = this.getCustomizationStyle.value === 'monogram' ? 3 : 2;

        displayLetters.slice(0, limit).forEach((letter, index) => {
          let charProductArray = [];
          let charSize = 'large';

          if (
              (this.getCustomizationStyle.value === 'monogram' && index === 0) ||
              (this.getCustomizationStyle.value === 'monogram' && index === 2)
          ) {
            charProductArray = this.getSmallLetterStyle.chars.filter((char) => {
              return char.key === letter;
            });
            charSize = 'small';
          } else {
            charProductArray = this.getLargeLetterStyle.chars.filter((char) => {
              return char.key === letter;
            });
            charSize = 'large';
          }

          const charObject = charProductArray[0];
          if (charObject) {
            letterArray.push({
              id: charObject.id,
              letter: letter,
              class: (`m-${charObject.class} m-${charObject.type} m-hitch-${charSize}`).trim(),
              image: charObject.image
            });
          }
        })
        return letterArray;
      },
      /** Returns placeholder text array depending on the customization style */
      placeholder() {
        return this.getCustomizationStyle.value === 'monogram' ? ['A', 'A', 'A'] : ['A', 'A'];
      }
    },
  };
</script>

<template>
  <div class="product-view__display m-plate">
    <div class="letter-display--plate js-custom-plate__display-wrap" :style="{backgroundImage: 'url('+variant.image+')'}">
      <div :class="`letter-display__inner letter-display__inner--hitch-${getCustomizationStyle.value}`" class="hitch-fluid-h" data-style="normal">
        <span v-for="(char, index) in displayLetters" :key="index" :class="`${char.class} ${char.class.split(' ')[2] === 'm-hitch-large' ? 'hitch-large' : 'hitch-small'}`">
          <img :src="char.image" :alt="char.letter" />
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .letter-display--plate {
    background-color: #ffffff;
    background-size: 68%; /* Was 60% */
    background-position: center center;
  }
  .letter-display__inner.hitch-fluid-h {
    height: 150px;
  }
  @media screen and (max-width: 1200px) {
    .letter-display__inner.hitch-fluid-h {
      height: 50%;
    }
  }
</style>
